export default "<div id=\"preloader\">\r\n    <div id=\"loader\" [ngClass]=\"loaderColor\"></div>\r\n</div>"